var site = site || {};
site.inits = [];

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.info = {
	init:function () {
		var $ExtrasOwlSettings = {
			items: 4,
			nav: true,
			margin: 30,
			navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
			autoHeight: false,
			dots: false,
			lazyLoad: true,
			lazyLoadEager: 2,
			responsive : {
				0 : {
					items: 1
				},
				600 : {
					items: 2
				},
				860 : {
					items: 3
				},
				1200 : {
					items: 4
				}
			}
		};

		site.owl.init('.info .items', $ExtrasOwlSettings);
	}
};
// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.info.init();
	var timeOut;

	var $body = $('body');
	if (!$body.is('.frontpage') && !$body.is('.admin')) {
		timeOut = timeoutInit();
	}
	$('.info .items').on('click', function(event){
		clearTimeout(timeOut)
		timeOut = timeoutInit();
	});
	function timeoutInit() {
		return setTimeout(function() {
			if($body.is('.info')) {
				window.location.href = '/info';
			}
			if($body.is('.upplysingar')) {
				window.location.href = '/upplysingar';
			}
		}, 300000);
	}
});